// Generic icon resolver. Slides receive icon *names* (strings) from the backend
// airline-content payload; this map converts them into Lucide components at
// render time. Kept here so airline slide files can be data-driven with no
// airline-specific strings in the source.
import {
  Film,
  Tv,
  Tv2,
  Music,
  Mic,
  Search,
  ScrollText,
  Tags,
  Globe,
  Globe2,
  ShieldCheck,
  ShieldAlert,
  Bot,
  BarChart3,
  Sparkles,
  Monitor,
  Smartphone,
  Wifi,
  Video,
  BookOpen,
  Award,
  Lightbulb,
  FileText,
  Cpu,
  Megaphone,
  Wrench,
  DollarSign,
  Layers,
  Check,
  ChevronDown,
  PiggyBank,
  Scale,
  Crown,
  Palette,
  Handshake,
  Clapperboard,
  BookOpenCheck,
  Users,
  Network,
  Leaf,
  Trophy,
  Rocket,
  Sun,
  Baby,
  Headphones,
} from "lucide-react";

export const IconMap = {
  Film, Tv, Tv2, Music, Mic,
  Search, ScrollText, Tags, Globe, Globe2,
  ShieldCheck, ShieldAlert, Bot, BarChart3, Sparkles,
  Monitor, Smartphone, Wifi, Video, BookOpen,
  Award, Lightbulb, FileText, Cpu, Megaphone,
  Wrench, DollarSign, Layers, Check, ChevronDown,
  PiggyBank, Scale, Crown, Palette, Handshake,
  Clapperboard, BookOpenCheck, Users, Network,
  Leaf, Trophy, Rocket, Sun, Baby, Headphones,
};

export const resolveIcon = (name) => IconMap[name] || Sparkles;
